import { Input } from "antd";
import { useEffect, useState } from "react";
import "./CrrBasicInputStyles.scss";

export default function CrrNumberInput(props) {
  const {
    name,
    qnId = "",
    selectField,
    placeholderText,
    onChange = "",
    setValue,
    disabled,
    defaultValue,
    answer,
    unit,
    isFieldFocused,
    setselectField,
    autoFocus,
    inputType,
    form,
    required,
  } = props;

  const [inputValue, setInputValue] = useState(
    defaultValue || answer?.text_answer
  );

  useEffect(() => {
    if (answer) {
      setInputValue(answer?.text_answer);
      form.setFieldsValue({
        [name]: answer?.text_answer,
      });
    }
    setValue(answer?.text_answer);
  }, []);

  const key = inputType === "integer" ? "integer_answer" : "text_answer";
  const formatResponse = (value) => {
    return { question_id: qnId, [key]: value };
  };

  const clearField = () => {
    form.setFields([
      {
        name,
        value: null,
        errors: ["Please fill a value greater than 0"],
      },
    ]);
    setInputValue(null);
    setValue(null);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/[^0-9.]/g, "");

    if (inputType === "integer") {
      // Allow only integers
      setInputValue(numericValue.replace(/[.]/g, ""));
    } else if (isNaN(Number(numericValue))) {
      // Check if numericValue is NaN
      setInputValue(inputValue.replace(/\.$/, ""));
    } else {
      //for floats
      setInputValue(numericValue);
    }

    setValue(numericValue);
  };

  const handleBlur = async () => {
    const numericValue = String(inputValue).replace(/[^0-9.]/g, "");

    if (required && (numericValue === "" || parseFloat(numericValue) === 0)) {
      try {
        await form.validateFields([name]);

        // If validation passes,
        onChange(qnId ? formatResponse(numericValue) : numericValue);
      } catch (error) {
        if (parseFloat(numericValue) === 0) {
          clearField();
        }
      }
    } else {
      if (inputType === "integer") {
        if (!Number.isInteger(parseFloat(inputValue))) {
          clearField();
          return;
        }
      }
      onChange(qnId ? formatResponse(numericValue) : numericValue);
    }
  };

  return (
    <div className="number-input-container">
      <Input
        className="login-input"
        placeholder={!selectField && placeholderText}
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onFocus={() => setselectField(true)}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {(isFieldFocused || inputValue) && unit}
    </div>
  );
}
